import React, { useEffect, useRef, useState } from "react";
import {
    HelpCircle,
    FileText,
    Link as LinkIcon,
    FileType2,
    Upload,
    FolderPlus,
    Pencil,
    Plus,
    ChevronDown,
    LucideIcon,
} from "lucide-react";

export type NewMenuAction =
    | "question"
    | "page"
    | "link"
    | "document"
    | "import"
    | "subfolder"
    | "request";

interface Props {
    onSelect: (action: NewMenuAction) => void;
}

const ITEMS: { action: NewMenuAction; label: string; Icon: LucideIcon }[] = [
    { action: "question", label: "Question", Icon: HelpCircle },
    { action: "page", label: "Blank page", Icon: FileText },
    { action: "link", label: "Link", Icon: LinkIcon },
    { action: "document", label: "Add a document", Icon: FileType2 },
    { action: "import", label: "Page from import", Icon: Upload },
    { action: "subfolder", label: "Folder", Icon: FolderPlus },
    { action: "request", label: "Page request", Icon: Pencil },
];

export default function NewCategoryMenu({ onSelect }: Props) {
    const [open, setOpen] = useState(false);
    const wrapRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!open) return;
        const handler = (e: MouseEvent) => {
            if (!wrapRef.current?.contains(e.target as Node)) setOpen(false);
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, [open]);

    function handleClick(action: NewMenuAction) {
        setOpen(false);
        onSelect(action);
    }

    return (
        <div className="m-cat-new-menu" ref={wrapRef}>
            <button
                type="button"
                className="m-btn m-btn-primary"
                onClick={() => setOpen(o => !o)}
            >
                <Plus size={16} /> New <ChevronDown size={14} />
            </button>
            {open && (
                <div className="m-cat-new-menu-popover">
                    {ITEMS.map(({ action, label, Icon }) => (
                        <button key={action} type="button" onClick={() => handleClick(action)}>
                            <Icon size={15} />
                            <span>{label}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
